<template>
  <div class="cma-scope-page">
    <div class="yn-biz-header">
      <span class="yn-biz-title">CMA能力范围</span>
      <div class="header-actions">
        <el-select
          v-model="major"
          clearable
          placeholder="检测大类"
          size="mini"
          style="width:160px"
          @change="loadData(1)"
        >
          <el-option v-for="m in majors" :key="m" :label="m" :value="m" />
        </el-select>
        <el-input
          v-model="keyword"
          clearable
          placeholder="搜索参数 / 标准名称 / 标准编号"
          size="mini"
          style="width:220px"
          @keyup.enter.native="loadData(1)"
          @clear="loadData(1)"
        />
        <el-button size="mini" type="primary" :loading="loading" @click="loadData(1)">查询</el-button>
        <el-button v-if="isAdminUser" size="mini" type="warning" plain :loading="importing" @click="reimport">重新导入</el-button>
        <span v-if="cert" class="stats-text">{{ cert.cert_no || '—' }} · 共 {{ total }} 条</span>
      </div>
    </div>

    <el-table
      v-loading="loading"
      :data="rows"
      border
      stripe
      size="small"
      class="scope-table"
      height="calc(100vh - 180px)"
    >
      <el-table-column label="序号" width="56" align="center" fixed>
        <template slot-scope="{ $index }">{{ rowIndex($index) }}</template>
      </el-table-column>
      <el-table-column prop="category_major" label="大类" width="168" show-overflow-tooltip fixed />
      <el-table-column prop="cat_name" label="检测对象" width="148" show-overflow-tooltip />
      <el-table-column prop="param_seq" label="参数序号" width="82" align="center" />
      <el-table-column prop="param_name" label="检测参数" width="120" show-overflow-tooltip />
      <el-table-column prop="std_name" label="依据标准（方法）" min-width="260" show-overflow-tooltip />
      <el-table-column prop="std_code" label="标准编号" width="130" show-overflow-tooltip />
      <el-table-column prop="scope_limit" label="限制范围" min-width="140" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.scope_limit || '—' }}</template>
      </el-table-column>
      <el-table-column prop="remark" label="说明" min-width="120" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.remark || '—' }}</template>
      </el-table-column>
    </el-table>

    <div class="pager">
      <el-pagination
        background
        layout="total, prev, pager, next, sizes"
        :total="total"
        :current-page.sync="page"
        :page-size.sync="pageSize"
        :page-sizes="[20, 50, 100, 200]"
        @current-change="loadData"
        @size-change="onSizeChange"
      />
    </div>
  </div>
</template>

<script>
import api from '@/utils/api'
import { isAdmin } from '@/utils/user'

export default {
  name: 'CmaScope',
  data() {
    return {
      loading: false,
      importing: false,
      rows: [],
      total: 0,
      page: 1,
      pageSize: 50,
      keyword: '',
      major: '',
      majors: [],
      cert: null
    }
  },
  computed: {
    user() { return JSON.parse(sessionStorage.getItem('yn_user') || '{}') },
    isAdminUser() { return isAdmin(this.user) }
  },
  mounted() {
    this.loadMeta().then(() => this.loadData(1))
  },
  methods: {
    rowIndex(idx) {
      return (this.page - 1) * this.pageSize + idx + 1
    },
    async loadMeta() {
      try {
        const res = await api.get('yn_cma_scope_meta', {})
        const d = res.data || {}
        this.cert = d.cert || null
        this.total = d.total || 0
        this.majors = d.majors || []
      } catch (e) {
        this.$message.error('加载能力范围元数据失败')
      }
    },
    async loadData(p) {
      if (p) this.page = p
      this.loading = true
      try {
        const res = await api.get('yn_cma_scope_list', {
          page: this.page,
          page_size: this.pageSize,
          keyword: this.keyword,
          major: this.major
        })
        const d = res.data || {}
        this.rows = d.items || []
        this.total = d.total || 0
      } catch (e) {
        this.$message.error('加载能力范围失败')
      } finally {
        this.loading = false
      }
    },
    onSizeChange() {
      this.loadData(1)
    },
    async reimport() {
      try {
        await this.$confirm(
          '将从 config/cma_scope_import.json 全量覆盖 CMA 能力范围，是否继续？',
          '重新导入',
          { type: 'warning' }
        )
      } catch (e) {
        return
      }
      this.importing = true
      try {
        const res = await api.get('yn_cma_scope_import', {})
        const d = res.data || {}
        if (d.error) {
          this.$message.error(d.error)
          return
        }
        this.$message.success(`已导入 ${d.imported || 0} 条`)
        await this.loadMeta()
        this.loadData(1)
      } catch (e) {
        this.$message.error('导入失败')
      } finally {
        this.importing = false
      }
    }
  }
}
</script>

<style scoped>
.cma-scope-page { min-height: 100%; }
.scope-intro {
  background: #fff;
  border-radius: 6px;
  padding: 14px 16px;
  margin-bottom: 12px;
  font-size: 14px;
  color: #303133;
  line-height: 1.6;
}
.intro-sub { margin-top: 6px; font-size: 12px; color: #909399; }
.addr { color: #606266; }
.scope-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.search-input { width: 280px; }
.filter-select { width: 220px; }
.scope-table { background: #fff; border-radius: 6px; }
.pager { margin-top: 12px; text-align: right; }
</style>
